import { getFormatedNumber } from "./api";
import { SagaContext } from "./store/tools/async-saga-types";

export function IsIpfxMobilityClientHost(): boolean {
    return window.ReactNativeWebView !== undefined
}

//#region WebSuite --> ReactNative Communications
export enum WebViewAction {
    Dial = 'ActionDial',
    ShowDialler = 'ActionShowDialer',
    FormatPhoneNumber = 'ActionFormatPhoneNumber',
}

export interface WebViewMessageData {
    // for host use. every Api must have a requestId so that the caller can correlate the request with the response.
    requestId?: string
    // for host use. To see if the request was successful or not
    result?: boolean
    action: WebViewAction
    data?: string
}

export function IpfxMobiltiyClientSend(message: WebViewMessageData) {
    try {
        if (window.ReactNativeWebView) {
            console.info('IpfxMobiltiyClientSend action' + message.action + ' data' + message.data)

            return window.ReactNativeWebView.postMessage(JSON.stringify(message))
        }
    } catch (e) {
        return 'error'
    }
}
//#endregion

//#region ReactNative --> WebSuite Communications
// every Api must have a requestId so that the caller can correlate the request with the response.
export interface MobilityClientApi {
    FormatPhoneNumber(requestId: string, number: string, e164: boolean, webrtc?: boolean): void
}

export function ExposeApiToMobilityClientHost(ctx: SagaContext) {
    if (!IsIpfxMobilityClientHost()) {
        // we stub out the method, so that we can response in the logging. For testing purposes only.
        window.ReactNativeWebView = {
            postMessage: (message: string) => {
                console.log('ReactNativeWebView postMessage', message)
                return ''
            },
        }
    }

    window.MobilityClientApi = {
        FormatPhoneNumber: async (requestId: string, number: string, e164: boolean, webrtc?: boolean) => {
            const formattedNumber = await getFormatedNumber(number, e164, webrtc)
            let response: WebViewMessageData = {
                requestId,
                result: true,
                action: WebViewAction.FormatPhoneNumber,
                data: formattedNumber,
            }
            window.ReactNativeWebView.postMessage(JSON.stringify(response))
        },
    }
}
//#endregion
